<template>
    <component class="Button" :class="{loading}" :is="type" v-bind="$attrs" :to="to" :href="href" @click="$emit('click')">
        <Loading v-if="loading"/>
        <slot></slot>
    </component>
</template>

<script>
import Loading from '@/components/Loading';

export default {
    name: 'Button',
    inheritAttrs: false,

    components: { Loading },

    props: {
        to: { type: String, default: '' },
        href: { type: String, default: '' },
        loading: { type: Boolean, default: false },
    },

    computed: {
        type() {
            if (this.to) return 'router-link';

            if (this.href) return 'a';

            return 'button';
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

$colors: (
    // primary: darken($brand-primary, 10%),
    primary: $button-primary-color,
    success: $green-color,
    warning: $yellow-color,
    danger: $red-color,
    info: $blue-color,
    black: $black-color,
    white: #fff,
    muted: $text-color-muted,
);

.Button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: 2px solid transparent;
    border-radius: $border-radius;
    height: 40px;
    line-height: 1;
    padding: 0 20px;
    outline: 0;
    background-color: #fff;
    font-weight: $font-weight-bold;
    font-size: 14px;
    color: $brand-primary;
    text-align: center;
    cursor: pointer;
    transition:
        border-color 125ms $ease-out,
        background-color 125ms $ease-out,
        opacity 125ms $ease-out,
        color 125ms $ease-out;

    &::-moz-focus-inner {
        border: none;
    }

    &:hover {
        color: rgba($brand-primary, 0.7);
    }

    &.disabled,
    &:disabled {
        pointer-events: none;
        opacity: 0.25;
    }

    &.loading {
        pointer-events: none;
        opacity: 0.6;
    }

    @each $name, $color in $colors {
        &.#{"" + $name} {
            background-color: $color;
            color: #fff;

            &:hover {
                background-color: rgba($color, 0.8);
            }

            @if ($color == white) {
                color: $text-color-primary;
            }
        }
    }

    &.outline {
        border-color: $text-color-primary;
        background-color: transparent;
        color: $text-color-primary;

        &:hover {
            background-color: transparent;
            opacity: 0.6;
        }

        @each $name, $color in $colors {
            &.#{"" + $name} {
                border-color: $color;
                color: $color;
            }
        }
    }

    &.block {
        display: flex;
        width: 100%;
    }

    &.link {
        background-color: transparent;
        color: $link-color;

        &:hover {
            background-color: transparent;
            color: rgba($link-color, 0.8);
        }

        @each $name, $color in $colors {
            &.#{"" + $name} {
                color: $color;

                &:hover {
                    color: rgba($color, 0.8);
                }
            }
        }
    }

    &.sm {
        height: 30px;
        border-width: 1px;
        padding: 0 10px;
        font-size: 14px;
    }

    &.lg {
        height: 50px;
        padding: 0 30px;
        font-size: 16px;
    }

    .Loading {
        margin-right: 30px;
    }
}
</style>
